export default "__VITE_PUBLIC_ASSET__5622ef0c__"